import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { useAppSelector } from '../hook';

export type CnpjState = {
  value: string;
};

const initialState: CnpjState = {
  value: '',
};

export const cnpjSlice = createSlice({
  name: 'cnpj',
  initialState,
  reducers: {
    storedCnpj: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },
  },
});

export const { storedCnpj } = cnpjSlice.actions;

export const getStoredCnpj = (state: RootState) => state.cnpj.value;
export const useGetStoredCnpj = () => useAppSelector(getStoredCnpj);
export default cnpjSlice.reducer;
